import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../../AuthContext/Authcontext';
import ReusableTable from '../../../Layout/ReusableTable';
import baseURL ,{defaultManagerId} from '../../../Apiurs/Apiurls';
import Navbar from '../../../Shared/AdminNavbar/Navbar';
import { FaTable, FaTh,   FaSave, FaEdit, FaTrash, FaComment , FaHistory , FaEye ,FaEnvelope } from 'react-icons/fa';
import { KanbanBoard } from './Kanban'; // Import the reusable Kanban components
import { RiFileList2Line } from "react-icons/ri";


function AdminOppLeads() {
  
  const [collapsed, setCollapsed] = useState(false);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState({});
  const [selectedAssociate, setSelectedAssociate] = useState({});
  const [selectedSalesManager, setSelectedSalesManager] = useState({});
  const [selectedSalesAssociate, setSelectedSalesAssociate] = useState({});
  const [selectedOppStatus, setSelectedOppStatus] = useState({});
  const [assignedData, setAssignedData] = useState({});
  const [managerChanged, setManagerChanged] = useState({});
  const [associateChanged, setAssociateChanged] = useState({});
  const [salesManagerChanged, setSalesManagerChanged] = useState({});
  const [salesAssociateChanged, setSalesAssociateChanged] = useState({});
  const [oppStatusChanged, setOppStatusChanged] = useState({});
  const [savedManagerIds, setSavedManagerIds] = useState({});
  const [viewMode, setViewMode] = useState('table'); // 'table' or 'kanban'

  const navigate = useNavigate();
  const { authToken, userId, userRole } = useContext(AuthContext);

  // Fetch managers and their team members
  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/employees/managers`, {
          
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setManagers(response.data.data);
      } catch (error) {
        console.error('Error fetching managers:', error);
        setMessage('Failed to fetch managers');
      }
    };
    fetchManagers();
  }, [authToken]);


  const handleKanbanManagerChange = (leadId, managerId) => {
  setSelectedManager((prev) => ({ ...prev, [leadId]: managerId }));
};

// Handle associate selection change in Kanban
const handleKanbanAssociateChange = (leadId, associateId) => {
  setSelectedAssociate((prev) => ({ ...prev, [leadId]: associateId }));
};

  // Fetch leads and assignments
  const fetchLeads = async () => {
    try {
      const leadsResponse = await axios.get(`${baseURL}/api/contacts/qualified`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const assignmentsResponse = await axios.get(`${baseURL}/api/lead-assignments`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (leadsResponse.status === 200) {
        const leads = leadsResponse.data;
        setData(leads);
        setFilteredData(leads);

        const managerSelections = {};
        const associateSelections = {};
        const salesManagerSelections = {};
        const salesAssociateSelections = {};
        const statusSelections = {};
        const assignments = assignmentsResponse.data;

        leads.forEach((lead) => {
          const assignment = assignments[lead.id] || {};
          managerSelections[lead.id] = assignment.manager_id?.toString() || '';
          associateSelections[lead.id] = assignment.associate_id?.toString() || '';
          salesManagerSelections[lead.id] = assignment.manager_1_id?.toString() || '';
          salesAssociateSelections[lead.id] = assignment.associate_1_id?.toString() || '';
          statusSelections[lead.id] = lead.opp_status;
        });

        setSelectedManager(managerSelections);
        setSelectedAssociate(associateSelections);
        setSelectedSalesManager(salesManagerSelections);
        setSelectedSalesAssociate(salesAssociateSelections);
        setSelectedOppStatus(statusSelections);
        setAssignedData(assignments);
      }
    } catch (error) {
      console.error('Error fetching leads or assignments:', error);
      setMessage(error.response?.data?.message || 'Failed to fetch leads or assignments');
    }
  };

  useEffect(() => {
    fetchLeads();
  }, [authToken, managers.length]);

  // Handle drop event in Kanban columns
  const handleDrop = async (leadId, newStatus) => {
    try {
      await handleOppStatusUpdate(leadId, newStatus);
    } catch (error) {
      console.error('Error updating status via drag and drop:', error);
      setMessage('Failed to update status via drag and drop');
    }
  };

  const handleOppStatusUpdate = async (leadId, newStatus = null) => {
    try {
      const statusToUpdate = newStatus || selectedOppStatus[leadId];

      const response = await axios.put(
        `${baseURL}/api/contacts/${leadId}/opp-status`,
        { opp_status: statusToUpdate },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      setMessage('Opportunity status updated successfully');
      
      if (!newStatus) {
        setOppStatusChanged((prev) => ({ ...prev, [leadId]: false }));
      }

      // Update data
      setData((prev) =>
        prev.map((lead) =>
          lead.id === leadId ? { ...lead, opp_status: statusToUpdate } : lead
        )
      );
      setFilteredData((prev) =>
        prev.map((lead) =>
          lead.id === leadId ? { ...lead, opp_status: statusToUpdate } : lead
        )
      );
    } catch (error) {
      console.error('Error updating opportunity status:', error);
      setMessage(error.response?.data?.message || 'Failed to update opportunity status');
      throw error;
    }
  };

  // Manager assignment handler for Kanban
  const handleKanbanManagerAssignment = async (leadId, managerId) => {
    try {
      if (!managerId) {
        setMessage('Please select a manager');
        return;
      }

      const isSelf = managerId.toString() === userId.toString();

      const response = await axios.put(
        `${baseURL}/api/leadcrm/${leadId}/assign-user`,
        {
          assigned_by: userId,
          assigned_to: managerId,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setMessage(
        isSelf ? 'Self-assignment saved successfully' : 'Manager assignment saved successfully'
      );
      
      setAssignedData((prev) => ({
        ...prev,
        [leadId]: response.data.data,
      }));
      
      // Update local state
      setData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: managerId }
            : lead
        )
      );
      setFilteredData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: managerId }
            : lead
        )
      );
    } catch (error) {
      console.error('Error assigning manager:', error);
      setMessage(error.response?.data?.message || 'Failed to save manager assignment');
    }
  };

  // Associate assignment handler for Kanban
  const handleKanbanAssociateAssignment = async (leadId, associateId) => {
    try {
      if (!associateId) {
        setMessage('Please select an associate');
        return;
      }

      const response = await axios.put(
        `${baseURL}/api/leadcrm/${leadId}/assign-user`,
        {
          assigned_by: userId,
          assigned_to: associateId,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setMessage('Associate assignment saved successfully');
      
      setAssignedData((prev) => ({
        ...prev,
        [leadId]: response.data.data,
      }));
      
      // Update local state
      setData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: associateId }
            : lead
        )
      );
      setFilteredData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: associateId }
            : lead
        )
      );
    } catch (error) {
      console.error('Error assigning associate:', error);
      setMessage(error.response?.data?.message || 'Failed to save associate assignment');
    }
  };

  // Existing handlers for table view
 const handleManagerAssignment = async (leadId) => {
    try {
      const selectedId = selectedManager[leadId];
      if (!selectedId) {
        setMessage('Please select a manager');
        return;
      }

      const isSelf = selectedId.toString() === userId.toString();

      const response = await axios.put(
        `${baseURL}/api/leadcrm/${leadId}/assign-user`,
        {
          assigned_by: userId,
          assigned_to: selectedId,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setMessage(
        isSelf ? 'Self-assignment saved successfully' : 'Manager assignment saved successfully'
      );
      setManagerChanged((prev) => ({ ...prev, [leadId]: false }));
      setSavedManagerIds((prev) => ({ ...prev, [leadId]: true }));
      setAssignedData((prev) => ({
        ...prev,
        [leadId]: response.data.data,
      }));
      // Update lead data to reflect new assignment
      setData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: selectedId }
            : lead
        )
      );
      setFilteredData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: selectedId }
            : lead
        )
      );
      // Reset associate selection after manager assignment
      setSelectedAssociate((prev) => ({ ...prev, [leadId]: '' }));
      setAssociateChanged((prev) => ({ ...prev, [leadId]: false }));
    } catch (error) {
      console.error('Error assigning manager:', error);
      setMessage(error.response?.data?.message || 'Failed to save manager assignment');
    }
  };

   const handleAssociateAssignment = async (leadId) => {
    try {
      const assignedTo = selectedAssociate[leadId];
      if (!assignedTo) {
        setMessage('Please select an associate');
        return;
      }

      const response = await axios.put(
        `${baseURL}/api/leadcrm/${leadId}/assign-user`,
        {
          assigned_by: userId,
          assigned_to: assignedTo,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setMessage('Associate assignment saved successfully');
      setAssociateChanged((prev) => ({ ...prev, [leadId]: false }));
      setAssignedData((prev) => ({
        ...prev,
        [leadId]: response.data.data,
      }));
      // Update lead data to reflect new assignment
      setData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: assignedTo }
            : lead
        )
      );
      setFilteredData((prev) =>
        prev.map((lead) =>
          lead.id === leadId
            ? { ...lead, assigned_by: userId.toString(), assigned_to: assignedTo }
            : lead
        )
      );
    } catch (error) {
      console.error('Error assigning associate:', error);
      setMessage(error.response?.data?.message || 'Failed to save associate assignment');
    }
  };

  // Sales Manager Save Button
// const handleSalesManagerAssignment = async (leadId) => {
//   try {
//     const selectedId = selectedSalesManager[leadId];
//     if (!selectedId) {
//       setMessage('Please select a Sales Manager');
//       return;
//     }

//     const response = await axios.put(
//       `${baseURL}/api/leadcrm/${leadId}/assign-user/user`,
//       {
//         assigned_by_1: userId,
//         assigned_to_1: selectedId,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${authToken}`,
//         },
//       }
//     );

//     setMessage('Sales Manager assignment saved successfully');
//     setSalesManagerChanged((prev) => ({ ...prev, [leadId]: false }));
//     setAssignedData((prev) => ({
//       ...prev,
//       [leadId]: { ...prev[leadId], ...response.data.data },
//     }));
//     // Update lead data to reflect new assignment
//     setData((prev) =>
//       prev.map((lead) =>
//         lead.id === leadId
//           ? { ...lead, assigned_by_1: userId.toString(), assigned_to_1: selectedId }
//           : lead
//       )
//     );
//     setFilteredData((prev) =>
//       prev.map((lead) =>
//         lead.id === leadId
//           ? { ...lead, assigned_by_1: userId.toString(), assigned_to_1: selectedId }
//           : lead
//       )
//     );
//     // Reset sales associate selection after manager assignment
//     setSelectedSalesAssociate((prev) => ({ ...prev, [leadId]: '' }));
//     setSalesAssociateChanged((prev) => ({ ...prev, [leadId]: false }));
//   } catch (error) {
//     console.error('Error assigning Sales Manager:', error);
//     setMessage(error.response?.data?.message || 'Failed to save Sales Manager assignment');
//   }
// };

// const handleSalesAssociateAssignment = async (leadId) => {
//   try {
//     const assignedTo = selectedSalesAssociate[leadId];
//     if (!assignedTo) {
//       setMessage('Please select a Sales Associate');
//       return;
//     }

//     const response = await axios.put(
//       `${baseURL}/api/leadcrm/${leadId}/assign-user/user`,
//       {
//         assigned_by_1: userId,
//         assigned_to_1: assignedTo,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${authToken}`,
//         },
//       }
//     );

//     setMessage('Sales Associate assignment saved successfully');
//     setSalesAssociateChanged((prev) => ({ ...prev, [leadId]: false }));
//     setAssignedData((prev) => ({
//       ...prev,
//       [leadId]: { ...prev[leadId], ...response.data.data },
//     }));
//     // Update lead data to reflect new assignment
//     setData((prev) =>
//       prev.map((lead) =>
//         lead.id === leadId
//           ? { ...lead, assigned_by_1: userId.toString(), assigned_to_1: assignedTo }
//           : lead
//       )
//     );
//     setFilteredData((prev) =>
//       prev.map((lead) =>
//         lead.id === leadId
//           ? { ...lead, assigned_by_1: userId.toString(), assigned_to_1: assignedTo }
//           : lead
//       )
//     );
//   } catch (error) {
//     console.error('Error assigning Sales Associate:', error);
//     setMessage(error.response?.data?.message || 'Failed to save Sales Associate assignment');
//   }
// };
// Sales Associate Save Button
const handleSalesAssociateAssignment = async (leadId) => {
  try {
    const assignedTo = selectedSalesAssociate[leadId];
    const defaultSalesManagerId = defaultManagerId; // ✅ Default Sales Manager ID

    if (!assignedTo) {
      setMessage('Please select a Sales Associate');
      return;
    }

    const response = await axios.put(
      `${baseURL}/api/leadcrm/${leadId}/assign-user/user`,
      {
        assigned_by_1: userId,               // current logged-in user assigning
        assigned_to_1: assignedTo,           // assigned sales associate
        manager_id: defaultSalesManagerId,   // ✅ fixed sales manager id
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    setMessage('Sales Associate assignment saved successfully');
    setSalesAssociateChanged((prev) => ({ ...prev, [leadId]: false }));
    setAssignedData((prev) => ({
      ...prev,
      [leadId]: { ...prev[leadId], ...response.data.data },
    }));

    // ✅ Update the lead data with default manager and selected associate
    setData((prev) =>
      prev.map((lead) =>
        lead.id === leadId
          ? {
              ...lead,
              assigned_by_1: userId.toString(),
              assigned_to_1: assignedTo,
              manager_id: defaultSalesManagerId,
            }
          : lead
      )
    );

    setFilteredData((prev) =>
      prev.map((lead) =>
        lead.id === leadId
          ? {
              ...lead,
              assigned_by_1: userId.toString(),
              assigned_to_1: assignedTo,
              manager_id: defaultSalesManagerId,
            }
          : lead
      )
    );
  } catch (error) {
    console.error('Error assigning Sales Associate:', error);
    setMessage(error.response?.data?.message || 'Failed to save Sales Associate assignment');
  }
};



  const handleEdit = (row) => {
    navigate(`/a-edit-lead/${row.id}`);
  };

  const handleDelete = async (leadId) => {
    if (window.confirm('Are you sure you want to delete this lead?')) {
      try {
        await axios.delete(`${baseURL}/api/contacts/${leadId}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        setMessage('Lead deleted successfully');
        fetchLeads();
      } catch (error) {
        console.error('Error deleting lead:', error);
        setMessage(error.response?.data?.message || 'Failed to delete lead');
      }
    }
  };

  const handleView = (lead) => {
    navigate(`/view-lead/${lead.id}`, { state: { lead } });
  };

  const handleComment = (lead) => {
    navigate(`/a-opp-comments/${lead.id}`, { state: { leadid: lead.id } });
  };

  // Table columns (same as your existing columns)
  // Table columns (same as your existing columns)
const TruncateCell = ({ value, maxLength = 20 }) => {
  if (value === null || value === undefined) {
    return <span>-</span>;
  }
  const str = String(value);
  return (
    <div
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: `${maxLength * 8}px`,
      }}
      title={str}
    >
      {str.length > maxLength ? str.slice(0, maxLength) + '...' : str}
    </div>
  );
};

const columns = [
  {
    key: 'leadId',
    title: 'LeadID',
    render: (row) => <TruncateCell value={`Lead00${row.id}`} maxLength={10} />,
  },
  {
    key: 'lead_name',
    title: 'Lead Name',
    render: (row) => (
      <span
        className="text-primary"
        style={{ cursor: "pointer",  }}
        onClick={() => handleView(row)}
        title="Click to view lead"
      >
        <TruncateCell value={row.lead_name} maxLength={15} />
      </span>
    ),
  },
  {
    key: 'lead_source',
    title: 'Source',
    render: (row) => <TruncateCell value={row.lead_source} maxLength={12} />,
  },
  {
    key: 'contact_number',
    title: 'Contact Number',
    render: (row) => <TruncateCell value={row.contact_number} maxLength={12} />,
  },
  {
    key: 'email',
    title: 'Email',
    render: (row) => <TruncateCell value={row.email} maxLength={20} />,
  },
  {
    key: 'quotation_status',
    title: 'Quotation Status',
    render: (row) => {
      const status = row.quotation_status || 'Not Quoted';
      let badgeClass = '';
      
      // Define badge classes based on status
      switch (status.toLowerCase()) {
        case 'sent':
          badgeClass = 'badge bg-success';
          break;
        case 'approved':
          badgeClass = 'badge bg-secondary';
          break;
        case 'rejected':
          badgeClass = 'badge bg-danger';
          break;
        case 'accepted':
          badgeClass = 'badge bg-info';
          break;
        case 'rejected':
          badgeClass = 'badge bg-dark';
          break;
        default:
          badgeClass = 'badge bg-light text-dark';
      }
      
      return (
        <span className={badgeClass} style={{ fontSize: '0.75rem', padding: '0.35em 0.65em' }}>
          {status}
        </span>
      );
    },
  },
  {
    key: 'opp_status',
    title: 'Status',
    render: (row) => {
      const leadId = row.id;
      return (
        <div className="d-flex align-items-center gap-2" style={{ minWidth: '200px' }}>
          <select
            className="form-select form-select-sm"
            value={selectedOppStatus[leadId] || 'Prospecting'}
            onChange={(e) => {
              const newStatus = e.target.value;
              setSelectedOppStatus((prev) => ({ ...prev, [leadId]: newStatus }));
              setOppStatusChanged((prev) => ({ ...prev, [leadId]: true }));
            }}
          >
            <option value="Prospecting">Prospecting</option>
            <option value="Proposal Sent">Proposal Sent</option>
            <option value="Negotiation">Negotiation</option>
            <option value="Regret">Regret</option>
            <option value="Closed Won">Closed Won</option>
            <option value="Closed Lost">Closed Lost</option>
            <option value="On Hold">On Hold</option>
          </select>
          <button
            className="btn btn-sm btn-success"
            onClick={() => handleOppStatusUpdate(leadId)}
            disabled={!oppStatusChanged[leadId]}
            title="Save Opp Status"
          >
            <FaSave />
          </button>
        </div>
      );
    },
  },
  // Quotation Manager Column - Only show managers with role "manager"
  {
    key: 'manager',
    title: 'Quotation Manager',
    render: (row) => {
      const leadId = row.id;
      const currentAssignment = assignedData[leadId] || {};
      const isSelfAssigned = currentAssignment.manager_id === userId.toString();
      
      // Filter managers with role "manager"
      const quotationManagers = managers.filter(manager => manager.role === 'manager');

      return (
        <div className="d-flex align-items-center gap-2" style={{ minWidth: '190px' }}>
          <select
            className="form-select form-select-sm"
            value={selectedManager[leadId] || currentAssignment.manager_id || ''}
            onChange={(e) => {
              const newManagerId = e.target.value;
              setSelectedManager((prev) => ({ ...prev, [leadId]: newManagerId }));
              setManagerChanged((prev) => ({ ...prev, [leadId]: true }));
              setSelectedAssociate((prev) => ({ ...prev, [leadId]: '' }));
              setAssociateChanged((prev) => ({ ...prev, [leadId]: false }));
              setSavedManagerIds((prev) => ({ ...prev, [leadId]: false }));
            }}
          >
            <option value="">Select Manager</option>
            <option
              value={userId}
              style={{
                fontWeight: isSelfAssigned ? 'bold' : 'normal',
                backgroundColor: isSelfAssigned ? '#e6f7ff' : 'transparent',
              }}
            >
              Self {isSelfAssigned ? ' (Assigned)' : ''}
            </option>
            {quotationManagers.map((manager) => {
              const isSelected = currentAssignment.manager_id === manager.id.toString();
              return (
                <option
                  key={manager.id}
                  value={manager.id}
                  style={{
                    fontWeight: isSelected ? 'bold' : 'normal',
                    backgroundColor: isSelected ? '#e6f7ff' : 'transparent',
                  }}
                >
                  {manager.name}
                  {isSelected ? ' (Assigned)' : ''}
                </option>
              );
            })}
          </select>
          <button
            className="btn btn-sm btn-success"
            onClick={() => handleManagerAssignment(leadId)}
            disabled={!managerChanged[leadId]}
            title="Save Manager"
          >
            <FaSave />
          </button>
        </div>
      );
    },
  },
  // Quotation Associate Column - Only show team members with role "employee"
  {
    key: 'associate',
    title: 'Quotation Associate',
    render: (row) => {
      const leadId = row.id;
      const currentAssignment = assignedData[leadId] || {};
      const managerId = selectedManager[leadId] || currentAssignment.manager_id || '';
      const manager = managers.find((m) => m.id.toString() === managerId);
      // Filter team members with role "employee"
      const quotationAssociates = manager?.teamMembers?.filter(member => member.role === 'employee') || [];

      return (
        <div className="d-flex align-items-center gap-2" style={{ minWidth: '190px' }}>
          <select
            className="form-select form-select-sm"
            value={selectedAssociate[leadId] || currentAssignment.associate_id || ''}
            onChange={(e) => {
              const newAssociateId = e.target.value;
              setSelectedAssociate((prev) => ({ ...prev, [leadId]: newAssociateId }));
              setAssociateChanged((prev) => ({ ...prev, [leadId]: true }));
            }}
            disabled={!managerId}
          >
            <option value="">Select Associate</option>
            {quotationAssociates.map((member) => {
              const isSelected = currentAssignment.associate_id === member.id.toString();
              return (
                <option
                  key={member.id}
                  value={member.id}
                  style={{
                    fontWeight: isSelected ? 'bold' : 'normal',
                    backgroundColor: isSelected ? '#e6f7ff' : 'transparent',
                  }}
                >
                  {member.name}
                  {isSelected ? ' (Assigned)' : ''}
                </option>
              );
            })}
          </select>
          <button
            className="btn btn-sm btn-success"
            onClick={() => handleAssociateAssignment(leadId)}
            disabled={!associateChanged[leadId] || !managerId}
            title="Save Associate"
          >
            <FaSave />
          </button>
        </div>
      );
    },
  },
  // Sales Manager Column - Only show managers with role "s-manager"
  // {
  //   key: 'salesManager',
  //   title: 'Sales Manager',
  //   render: (row) => {
  //     const leadId = row.id;
  //     const currentAssignment = assignedData[leadId] || {};
  //     const isSelfAssigned = currentAssignment.manager_1_id === userId.toString();
      
  //     // Filter managers with role "s-manager"
  //     const salesManagers = managers.filter(manager => manager.role === 's-manager');

  //     return (
  //       <div className="d-flex align-items-center gap-2" style={{ minWidth: '190px' }}>
  //         <select
  //           className="form-select form-select-sm"
  //           value={selectedSalesManager[leadId] || currentAssignment.manager_1_id?.toString() || ''}
  //           onChange={(e) => {
  //             const newManagerId = e.target.value;
  //             setSelectedSalesManager((prev) => ({ ...prev, [leadId]: newManagerId }));
  //             setSalesManagerChanged((prev) => ({ ...prev, [leadId]: true }));
  //             setSelectedSalesAssociate((prev) => ({ ...prev, [leadId]: '' }));
  //             setSalesAssociateChanged((prev) => ({ ...prev, [leadId]: false }));
  //           }}
  //         >
  //           <option value="">Select Sales Manager</option>
  //           <option
  //             value={userId}
  //             style={{
  //               fontWeight: isSelfAssigned ? 'bold' : 'normal',
  //               backgroundColor: isSelfAssigned ? '#e6f7ff' : 'transparent',
  //             }}
  //           >
  //             Self {isSelfAssigned ? ' (Assigned)' : ''}
  //           </option>
  //           {salesManagers.map((manager) => {
  //             const isSelected = currentAssignment.manager_1_id?.toString() === manager.id.toString();
  //             return (
  //               <option
  //                 key={manager.id}
  //                 value={manager.id}
  //                 style={{
  //                   fontWeight: isSelected ? 'bold' : 'normal',
  //                   backgroundColor: isSelected ? '#e6f7ff' : 'transparent',
  //                 }}
  //               >
  //                 {manager.name}
  //                 {isSelected ? ' (Assigned)' : ''}
  //               </option>
  //             );
  //           })}
  //         </select>
  //         <button
  //           className="btn btn-sm btn-success"
  //           onClick={() => handleSalesManagerAssignment(leadId)}
  //           disabled={!salesManagerChanged[leadId]}
  //           title="Save Sales Manager"
  //         >
  //           <FaSave />
  //         </button>
  //       </div>
  //     );
  //   },
  // },


//   {
//   key: 'salesAssociate',
//   title: 'Sales Associate',
//   render: (row) => {
//     const leadId = row.id;
//     const currentAssignment = assignedData[leadId] || {};
//     const salesManagerId = selectedSalesManager[leadId] || currentAssignment.manager_1_id?.toString() || '';
    
//     // Find the selected sales manager
//     const salesManager = managers.find((m) => m.id.toString() === salesManagerId);
    
//     // Get team members from the manager object
//     const salesAssociates = salesManager?.teamMembers?.filter(member => member.role === 's-employee') || [];

//     return (
//       <div className="d-flex align-items-center gap-2" style={{ minWidth: '190px' }}>
//         <select
//           className="form-select form-select-sm"
//           value={selectedSalesAssociate[leadId] || currentAssignment.associate_1_id?.toString() || ''}
//           onChange={(e) => {
//             const newAssociateId = e.target.value;
//             setSelectedSalesAssociate((prev) => ({ ...prev, [leadId]: newAssociateId }));
//             setSalesAssociateChanged((prev) => ({ ...prev, [leadId]: true }));
//           }}
//           disabled={!salesManagerId}
//         >
//           <option value="">Select Sales Associate</option>
//           {salesAssociates.map((member) => {
//             const isSelected = currentAssignment.associate_1_id?.toString() === member.id.toString();
//             return (
//               <option
//                 key={member.id}
//                 value={member.id}
//                 style={{
//                   fontWeight: isSelected ? 'bold' : 'normal',
//                   backgroundColor: isSelected ? '#e6f7ff' : 'transparent',
//                 }}
//               >
//                 {member.name}
//                 {isSelected ? ' (Assigned)' : ''}
//               </option>
//             );
//           })}
//         </select>
//         <button
//           className="btn btn-sm btn-success"
//           onClick={() => handleSalesAssociateAssignment(leadId)}
//           disabled={!salesAssociateChanged[leadId] || !salesManagerId}
//           title="Save Sales Associate"
//         >
//           <FaSave />
//         </button>
//       </div>
//     );
//   },
// },
  // Sales Associate Column - Only show team members with role "s-employee"
// Sales Associate Column - Uses default Sales Manager (id = defaultManagerId)
{
  key: 'salesAssociate',
  title: 'Sales Associate',
  render: (row) => {
    const leadId = row.id;
    const currentAssignment = assignedData[leadId] || {};
    const defaultSalesManagerId = defaultManagerId; // ✅ fixed manager id

    // Find default manager
    const defaultManager = managers.find((m) => m.id === defaultSalesManagerId);

    // Get sales associates under default manager
    const salesAssociates =
      defaultManager?.teamMembers?.filter((member) => member.role === 's-employee') || [];

    return (
      <div className="d-flex align-items-center gap-2" style={{ minWidth: '190px' }}>
        <select
          className="form-select form-select-sm"
          value={selectedSalesAssociate[leadId] || currentAssignment.associate_1_id?.toString() || ''}
          onChange={(e) => {
            const newAssociateId = e.target.value;
            setSelectedSalesAssociate((prev) => ({ ...prev, [leadId]: newAssociateId }));
            setSalesAssociateChanged((prev) => ({ ...prev, [leadId]: true }));
          }}
        >
          <option value="">Select Sales Associate</option>
          {salesAssociates.map((member) => {
            const isSelected = currentAssignment.associate_1_id?.toString() === member.id.toString();
            return (
              <option
                key={member.id}
                value={member.id}
                style={{
                  fontWeight: isSelected ? 'bold' : 'normal',
                  backgroundColor: isSelected ? '#e6f7ff' : 'transparent',
                }}
              >
                {member.name}
                {isSelected ? ' (Assigned)' : ''}
              </option>
            );
          })}
        </select>
        <button
          className="btn btn-sm btn-success"
          onClick={() => handleSalesAssociateAssignment(leadId)}
          disabled={!salesAssociateChanged[leadId]}
          title="Save Sales Associate"
        >
          <FaSave />
        </button>
      </div>
    );
  },
},

  {
    key: 'actions',
    title: 'Actions',
    render: (row) => (
      <div className="d-flex gap-2">
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() =>
            navigate(`/view-lead/${row.id}`, { state: { lead: row } })
          }
          title="View"
        >
          <RiFileList2Line  />
        </button>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() =>
            navigate(`/opportunity_view/${row.id}`, { state: { lead: row } })
          }
          title="View-Edit"
        >
          <FaEye  />
        </button>
        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => handleDelete(row.id)}
          title="Delete"
        >
          <FaTrash />
        </button>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => navigate(`/a-opp-comments/${row.id}`, { state: { leadid: row.id } })}
          title="Comment"
        >
          <FaComment />
        </button>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => navigate(`/view-sent-quotations/${row.id}`, { state: { leadid: row.id } })}
          title="History"
        >
          <FaHistory />
        </button>
         <button
                                className="btn btn-sm btn-outline-success"
                                onClick={() =>
                                  navigate(`/a-send-email/${row.id}`, {
                                    state: { leadid: row.id, email: row.email },
                                  })
                                }
                                title="Send Email"
                              >
                                <FaEnvelope />
                              </button>
      </div>
    ),
  },
];
  return (
    <div className="AdminLeadscontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`AdminLeads ${collapsed ? 'collapsed' : ''}`}>
        <div className="AdminLeads-container mb-5">
          <div className="AdminLeads-table-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4>Admin Opportunity Leads</h4>
              <div className="view-mode-buttons">
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setViewMode('table')}
                >
                  <FaTable /> Table View
                </button>
                <button
                  className={`btn ms-2 ${viewMode === 'kanban' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setViewMode('kanban')}
                >
                  <FaTh /> Kanban View
                </button>
              </div>
            </div>

            {message && (
              <div className={`alert ${message.includes('successfully') ? 'alert-success' : 'alert-danger'}`}>
                {message}
              </div>
            )}

            {viewMode === 'table' ? (
              <ReusableTable
                data={filteredData}
                columns={columns}
                initialEntriesPerPage={5}
                searchPlaceholder="Search leads..."
              />
            ) : (
              <KanbanBoard
  leads={filteredData}
  onView={handleView}
 // onEdit={handleEdit}
  onDelete={handleDelete}
  onComment={handleComment}
  onStatusUpdate={handleOppStatusUpdate}
  onManagerAssignment={handleKanbanManagerAssignment}
  onAssociateAssignment={handleKanbanAssociateAssignment}
  onDrop={handleDrop}
  managers={managers}
  assignedData={assignedData}
  userId={userId}
  selectedManager={selectedManager} // Pass the state
  selectedAssociate={selectedAssociate}
  onManagerChange={handleKanbanManagerChange} // Pass the handlers
  onAssociateChange={handleKanbanAssociateChange}
/>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .kanban-board {
          overflow-x: auto;
          padding: 10px;
          background: #f5f5f5;
          min-height: 80vh;
        }
        
        .kanban-columns-container {
          display: flex;
          gap: 15px;
          min-width: max-content;
        }
        
        .kanban-column {
          min-width: 350px;
          background: #f8f9fa;
          border-radius: 8px;
          padding: 10px;
          border: 2px dashed transparent;
          transition: all 0.3s ease;
        }
        
        .kanban-column.drag-over {
          border-color: #007bff;
          background: #e3f2fd;
        }
        
        .kanban-column-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          background: white;
          border-radius: 6px;
          margin-bottom: 10px;
          font-weight: bold;
        }
        
        .kanban-column-body {
          min-height: 600px;
          transition: background-color 0.2s;
        }
        
        .kanban-column-body.drag-over {
          background-color: #e3f2fd;
        }
        
        .kanban-card {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          overflow: hidden;
          margin-bottom: 10px;
          transition: transform 0.2s;
        }
        
        .kanban-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        
        .kanban-card:active {
          cursor: grabbing;
        }
        
        .kanban-card-header {
          padding: 12px;
          color: black;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: bold;
        }
        
        .kanban-status-badge {
          background: rgba(0,0,0,0.2);
          padding: 4px 12px;
          border-radius: 15px;
          font-size: 0.8em;
          font-weight: bold;
        }
        
        .kanban-card-body {
          padding: 12px;
        }
        
        .kanban-field {
          margin-bottom: 8px;
          font-size: 0.9em;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .kanban-field-group {
          margin-bottom: 10px;
        }
        
        .kanban-field-group label {
          font-size: 0.85em;
          margin-bottom: 4px;
          display: block;
        }
        
        .kanban-field strong {
          margin-right: 5px;
          min-width: 60px;
        }
        
        .kanban-actions {
          border-top: 1px solid #eee;
          padding-top: 12px;
        }
        
        .kanban-empty-state {
          text-align: center;
          padding: 20px;
          color: #6c757d;
          font-style: italic;
        }
        
        .view-mode-buttons {
          display: flex;
          gap: 10px;
        }
      `}</style>
    </div>
  );
}

export default AdminOppLeads;